import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ui from "./index.module.css";
import DotIcon from "../../../../../assets/icons/dot-icon";
import { useSelector } from "react-redux";
import { selectIsGuestUserRole } from "../../../../../store/reducers/user/UserInformationSlice";
import ConfirmDialogModal from "../../../../../components/ConfirmDialogModal";
import { ROUTES } from "../../../../../constants/routes";

const PlanCourseCollapse = ({ weeksList, planID, planName, data }) => {
  const navigate = useNavigate();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const isGuestUser = useSelector(selectIsGuestUserRole);

  const handleShowBodyContent = (week, isLocked, specialties) => {
    if (specialties.length === 0) return;
    if (isLocked) {
      setIsConfirmModalOpen(true);
      return;
    }
    const qs = new URLSearchParams({
      plan: String(planID),
      week: String(week),
      specialties: String(specialties?.join(",")),
    });
    if (planName) qs.set("planName", planName);
    navigate(`${ROUTES.PLATAFORMA_PLANES_CONTENIDO}?${qs.toString()}`);
  };
  //FALTA COLOCAR LAS FUNCIONES PARA EL PAGO
  const handleAcceptConfirm = () => {
    setIsConfirmModalOpen(false);
    navigate(ROUTES.CHECKOUT);
  };

  const handleCancelConfirm = () => {
    setIsConfirmModalOpen(false);
  };

  return (
    <section>
      <div className={ui.courseContainer}>
        {weeksList.length > 0 &&
          weeksList?.map((week, index) => {
            const isLocked = isGuestUser && index > 0;
            return (
              <button
                type="button"
                className={`${ui.courseItem} ${isLocked ? ui.lockedItem : ""}`}
                key={week?.week_id}
                onClick={() =>
                  handleShowBodyContent(
                    week?.week_number,
                    isLocked,
                    week?.specialties,
                  )
                }
              >
                <div className={ui.itemContent}>
                  <div className={ui.contentHead}>
                    <div className={ui.headTop}>
                      <div className={ui.courseWeekTitle}>
                        <DotIcon />
                        <h6 className={ui.courseWeek}>
                          Semana {index + 1} -{" "}
                          {week?.week_names.join(" / ")}
                        </h6>
                      </div>
                    </div>
                    <div className={ui.headBottom}>
                      <div className={ui.classDays}>
                        {week?.resources.map((resource, index) => {
                          return (
                            <div className={ui.dayClass} key={index}>
                              <p>{resource[0]} - </p>
                              <span>{resource[1]}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
      </div>
      <ConfirmDialogModal
        isOpen={isConfirmModalOpen}
        onAccept={handleAcceptConfirm}
        onCancel={handleCancelConfirm}
        title="Desbloquea este contenido"
        description={
          <>
            <p className="m-0">
              Este contenido forma parte del programa completo.
            </p>
            <p className="m-0">
              Accede a todas las lecciones, simuladores y recursos diseñados
              para el ENARM.
            </p>
          </>
        }
        acceptText="Ver todo el curso"
        cancelText="Seguir explorando"
      />
    </section>
  );
};

export default PlanCourseCollapse;
